import { render, staticRenderFns } from "./PortrayalResult.vue?vue&type=template&id=5970d998&"
import script from "./PortrayalResult.ts?vue&type=script&lang=ts&"
export * from "./PortrayalResult.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports